var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "design-summary" }, [
    _c("div", [
      _c("span", [
        _vm._v(
          _vm._s(_vm.se_design.name) +
            " | " +
            _vm._s(_vm.se_design.pretty_miscstats)
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(" | ")]),
      _vm._v(" "),
      _c(
        "span",
        {
          class: { "has-error": _vm.has_parts_list_load_error },
          attrs: { title: _vm.parts_list_load_title }
        },
        [_vm._v("Parts: " + _vm._s(_vm.parts_list_name))]
      ),
      _vm._v(" "),
      _vm.has_parts_list_load_error
        ? _c(
            "span",
            { class: { "has-error": _vm.has_parts_list_load_error } },
            [_vm._v(" (WRONG PARTS LIST! EVERYTHING MAY BE INVALID!)")]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("span", [_vm._v(_vm._s(_vm.se_design.stats_raw.toFixed(2)))]),
        _vm._v(" "),
        _c("span", [_vm._v(" | ")]),
        _vm._v(" "),
        _c("span", [
          _vm._v("[" + _vm._s(_vm.se_design.cost_BR_raw.toFixed(2)) + "]br")
        ]),
        _vm._v(" "),
        _c("span", [
          _vm._v("[" + _vm._s(_vm.se_design.cost_SR_raw.toFixed(2)) + "]sr")
        ]),
        _vm._v(" "),
        _vm.se_design.refit_valid
          ? [
              _c("span", [_vm._v(" | Refit ")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "[" +
                    _vm._s(_vm.se_design.refit_cost_BR_raw.toFixed(2)) +
                    "]br"
                )
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "[" +
                    _vm._s(_vm.se_design.refit_cost_SR_raw.toFixed(2)) +
                    "]sr"
                )
              ])
            ]
          : _vm._e(),
        _vm._v(" "),
        _c("span", [_vm._v(" | ")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.se_design.cost_crew_raw.toFixed(2)))]),
        _vm._v(" "),
        _c("span", [_vm._v(" | ")]),
        _vm._v(" "),
        _c("span", [_vm._v("[" + _vm._s(_vm.build_time) + "]years")])
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "span",
          {
            staticClass: "design-power-summary",
            class: {
              "has-error":
                !_vm.se_design.omit_validation &&
                _vm.se_design.cost_power_raw >
                  _vm.se_design.power_generation_raw
            }
          },
          [
            _vm._v(
              "Power[" +
                _vm._s(_vm.se_design.cost_power_raw.toFixed(2)) +
                "/" +
                _vm._s(_vm.se_design.power_generation_raw.toFixed(2)) +
                "]"
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "design-weight-summary",
            class: {
              "has-error":
                !_vm.se_design.omit_validation &&
                _vm.se_design.weight_internal > _vm.se_design.frame_max_size_raw
            }
          },
          [
            _vm._v(
              "Internal[" +
                _vm._s(_vm.se_design.weight_internal.toFixed(2)) +
                "/" +
                _vm._s(_vm.se_design.frame_max_size_raw.toFixed(2)) +
                "]"
            )
          ]
        ),
        _vm._v(" "),
        _vm._l(_vm.se_design.subsystems, function(ss) {
          return _c(
            "span",
            {
              key: ss.name,
              staticClass: "subsystem-weight-summary",
              class: {
                "has-error":
                  !ss.omit_validation && ss.weight_internal > ss.weight_cap
              }
            },
            [
              _vm._v(
                _vm._s(ss.name) +
                  "[" +
                  _vm._s(ss.weight_internal.toFixed(2)) +
                  "/" +
                  _vm._s(ss.weight_cap.toFixed(2)) +
                  "] "
              )
            ]
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f04171c2", { render: render, staticRenderFns: staticRenderFns })
  }
}